var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-component",style:({ width: _vm.propsWidth, height: _vm.propsHeight })},[_vm._t("icon"),_vm._t("contact"),_c('div',{staticClass:"content d-flex justify-content-between"},[_vm._t("text")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }